var plugin_rtlignore_default = {
  "alignLeft": "eWHG4",
  "textWrapNowrap": "SFdVV",
  "alignRight": "Uz1gR",
  "alignCenter": "eM-cL",
  "sizeFullWidth": "YLKDq",
  "renderedInTable": "aDoCj",
  "sizeOriginal": "V9VMS",
  "sizeContent": "_8L55-",
  "sizeSmall": "_1TEe1",
  "sizeSmallCenter": "_2gBQx",
  "flex": "HYccX",
  "atomic": "k9xcN",
  "embed": "kRJDT",
  "horizontalScrollbar": "BISj1",
  "pluginContainerMobile": "ZEGvw"
};
export {
  plugin_rtlignore_default as default
};
//# sourceMappingURL=plugin.rtlignore-scss.js.map
